import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import Icon from '../../components/Icon/Icon';
import Popup from '../../components/Popup/Popup';
import { StatisticsDisplay } from './Statistics.model';
import styles from './Statistics.module.scss';
import { useStatistics } from './useStatistics';

const Statistics = () => {
	const { exportResourceStatistics, exportUserStatistics, state, toggleExportPopup } = useStatistics();
	const { email, resourceStatisticsInfo, showExportPopup, userStatisticsInfo } = state;

	const renderStatisticsCard = (item: StatisticsDisplay) => {
		const { extraContent, icon: { name, type }, label, value } = item;
		return <div className={styles.card}>
			<Icon name={name} type={type} width="32px" height="32px" color="light" />
			<div className={styles.cardContent}>
				<h3><FormattedMessage id={label} /></h3>
				<h2>{value}</h2>
			</div>
			{
				extraContent && <div className={`${styles.extraContent} ${styles.cardContent}`}>
					<h3><FormattedMessage id={extraContent.label} /></h3>
					<h2>{extraContent.value}</h2>
				</div>
			}
		</div>
	}

	return <div className={styles.pageContainer}>
		<div className={styles.pageContent}>
			<div className={styles.content}>
				<div className={styles.flexWrapper}>
					<h1><FormattedMessage id="navigation.resourceStatistics" /></h1>
					<Button type="primary" onClick={exportResourceStatistics} size="large">
						<FormattedMessage id="buttons.exportCSVtoMail" />
					</Button>
				</div>
				<div className={styles.flexWrapper}>
					{resourceStatisticsInfo.map((item) => renderStatisticsCard(item))}
				</div>
				<div className={styles.flexWrapper}>
					<h1><FormattedMessage id="navigation.userStatistics" /></h1>
					<Button type="primary" onClick={exportUserStatistics} size="large">
						<FormattedMessage id="buttons.exportCSVtoMail" />
					</Button>
				</div>
				<div className={styles.flexWrapper}>
				{userStatisticsInfo.map((item) => renderStatisticsCard(item))}
			</div>
			</div>
		</div>
		{showExportPopup && <Popup onClose={toggleExportPopup} size="small">
			<div className={styles.popupContent}>
				<Icon name="paper-plane" width="64px" height="64px" color="accent" />
				<p><FormattedMessage id="statistics.export.info" values={{ email }}/></p>
			</div>
		</Popup>}
	</div>
}

export default Statistics;